import { render, staticRenderFns } from "./purchase_supplier_list.vue?vue&type=template&id=77892184&scoped=true"
import script from "./purchase_supplier_list.vue?vue&type=script&lang=js"
export * from "./purchase_supplier_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77892184",
  null
  
)

export default component.exports